import React, {useRef, useState} from "react";
import TextareaAutosize from "react-textarea-autosize";
import "../../styles/components/chat/ChatInput.css";
import { ArrowForward } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";

const ChatInput = ({ isThinking, setOpen, handleInitialQuery, textareaRef, keywords, selectedChat,setPrompt }) => {
  const [chatText, setChatText] = useState("");

  const setQuery = ($event) => {
    const updatedText = $event.target.value;
    setChatText(updatedText);
    setPrompt(updatedText);
    if ($event.key === "Enter" && updatedText !== '') {
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    handleInitialQuery(chatText);
    setOpen(true); // Open the drawer when submitting
    setChatText(""); // Clear the input
    if (textareaRef.current) {
      textareaRef.current.value = ""; // Clear the textarea
    }
  };

  // Only render if no chat is selected
  if (selectedChat) {
    return null;
  }

  return (
    <>
      <div className="chat-input">
        <div className="chat-input-box">
          <TextareaAutosize
            rows={1}
            ref={textareaRef}
            minRows={1}
            maxRows={9}
            className="chat-input-textarea-field"
            placeholder="Ask anything about this calculator..."
            onChange={setQuery}
            value={chatText}
          />
        </div>
        {!isThinking && chatText && (
          <button className="chat-input-button-send" onClick={handleSubmit}>
            <ArrowForward />
          </button>
        )}
        {isThinking && (
          <button className="chat-input-button-send">
            <CircularProgress color="primary" size={30} sx={{ svg: { width: "30px", height: "30px" } }} />
          </button>
        )}
      </div>
    </>
  );
};

export default ChatInput;
